import React from 'react';
import { nanoid } from 'nanoid';
import { Link } from 'react-router-dom'
import { format, isValid} from "date-fns";
import { ka } from "date-fns/locale";

import Image from '../imageComponent'
import { BlogsCard } from './styled';

const BlogsCardComponent: React.FC<any> = ({ el }) => {
    const locales = { ka };

  return (
    <BlogsCard>
      <div className="image">
        <Link to={`/details/${el.slug}`}>
          <Image src={el.main_image} layout="fill" objectFit="cover" />
        </Link>
          <div className="category">{el.category?.map(el => (
            <Link key={nanoid()} to={`/?category=${el.slug}`}>{el.name}</Link>
          ))}</div>
      </div>
      <div className="main">
        <Link to={`/details/${el.slug}`}>{el.title}</Link>
        <p>{el.preview}</p>
        <div className="date">
          <span className="mob">{el.minutes} წთ</span>
          <span className="desc">{el.minutes} წუთის წასაკითხი</span>
          &nbsp; &middot; &nbsp;

          {isValid(new Date(el?.date)) ? format(new Date(el?.date), "dd MMMM yyyy", { locale: locales.ka } ) : (
            el?.date
          )}
        </div>
      </div>
    </BlogsCard>
  );
};

export default BlogsCardComponent;
